<ion-toolbar color="granate">
    <a class="cursor" [routerLink]="'/home'"><img src="../../../assets/imgs/logolinea.png" alt="" srcset="" id="logo"></a>
    <ion-buttons slot="end">
        <ion-button (click)="logOut()" title="Desconectar">
            <ion-icon title="Desconectar" slot="icon-only" name="log-out-outline" color="light" class="cursor ion-margin-end" size="large"></ion-icon>
        </ion-button>
    </ion-buttons>
</ion-toolbar>